module.exports = __webpack_public_path__ + "img/عمودی.99ad0ce3.png";